import { useMemo } from "react";
import { Calendar } from "../../ui/calendar";
import { toDateKey } from "./eventTypes";

export const EventCalendarView = ({ events, selectedDate, onSelectDate }) => {
  const eventDateKeys = useMemo(() => new Set(events.map((e) => e.date)), [events]);

  return (
    <div data-testid="event-calendar-view">
      <Calendar
        mode="single"
        selected={selectedDate}
        onSelect={onSelectDate}
        modifiers={{ hasEvents: (date) => eventDateKeys.has(toDateKey(date)) }}
        modifiersClassNames={{
          hasEvents:
            "relative after:content-[''] after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2 after:w-1.5 after:h-1.5 after:bg-twp-gold after:rounded-full",
        }}
        className="rounded-md border p-3"
      />
    </div>
  );
};
